import addDays from "date-fns/addDays"
import format from "date-fns/format"
import isAfter from "date-fns/isAfter"
import startOfDay from "date-fns/startOfDay"
import { DateTimeService } from "../../../services/date-time-service"
import { escapeHtml } from "../../utils"
import { TOTAL_APPROVED_HOURS_ROW_ID } from "./total-hours-row"
import type { TreeGridApprovedHourDateGroupRow, TreeGridApprovedHourRow } from "./types"

export const makeDateKey = (date: Date): string => {
  return format(date, "yyyy-MM-dd")
}

export const makeDateRange = (fromDate: Date, toDate: Date) => {
  const dates: Date[] = []
  let date = startOfDay(fromDate)
  const endDate = startOfDay(toDate)

  while (!isAfter(date, endDate)) {
    dates.push(date)
    date = addDays(date, 1)
  }

  return dates
}

export const makeActionButtonHtml = ({ action, label, icon }: { action: string; label: string; icon: string }) => {
  return `
    <button
      type="button"
      class="approved-hours-action approved-hours-action--${action}"
      data-approved-hours-action="${action}"
      title="${label}"
      aria-label="${label}"
    >
      <span class="material-symbols-rounded">${icon}</span>
    </button>
  `
}

export const makeStatusTip = ({ action, person, date, dateFormat, formatMessage }: MakeStatusTipProps) => {
  if (!person || !date) return ""

  const dateTimeService = new DateTimeService({ dateFormat, enableTimeComponent: true })
  const formattedDate = dateTimeService.format(date)

  return formatMessage({ action, person: escapeHtml(person), date: escapeHtml(formattedDate) })
}

export const isDateGroupRow = (row: TRow): row is TreeGridApprovedHourDateGroupRow => {
  return row.Def.Name === "DateGroup"
}

export const isHourReportRow = (row: TRow): row is TreeGridApprovedHourRow => {
  return row.Def.Name === "ApprovedHour"
}

export const isTotalHoursRow = (row: TRow): boolean => {
  return row.id === TOTAL_APPROVED_HOURS_ROW_ID
}

export const getDateGroupRows = (grid: TGrid): TreeGridApprovedHourDateGroupRow[] => {
  if (!grid) return []

  const rows = Object.values(grid.Rows)
  return rows.filter(isDateGroupRow)
}

type MakeStatusTipProps = {
  action: string
  person: string | null | undefined
  date: string | null | undefined
  dateFormat: string
  formatMessage: (values: { action: string; person: string; date: string }) => string
}
